import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
export class FeatureSelectorProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
}
//# sourceMappingURL=FeatureSelectorProperties.js.map